module.exports = __webpack_public_path__ + "files/2b8b766053e407674b3d4282ea4bc4f8.png";